export default {
  places: state => state.places,
  filteredPlaces(state, _, rootState) {
    if (rootState.app.searchString) {
      return state.places.filter(item => {
        return rootState.app.searchString
          .toLowerCase()
          .split(' ')
          .every(
            v =>
              item.Name.toLowerCase().includes(v) ||
              item.AddressText.toLowerCase().includes(v)
          )
      })
    }
    return state.places
  },
  ownedPlaces: state => state.ownedPlaces,
  place: state => state.place,
  totalSpots: state => state.totalSpots,
  availableSpots: state => state.availableSpots,
  sessions: state =>
    (state.sessions || []).filter(s => !s.deleted_at && !s.DeletedAt),
  nextAvailablePage: state => state.nextAvailablePage
}
